<template>
    <div role="status" aria-live="polite" :aria-label="localizations[lang].loading" class="SimpleSpinner">
        <svg-icon
            aria-hidden="true"
            icon="spinner"
            class="animate-spin text-theme-toolbar-icon [&_svg]:m-0"
            :width="width"
            :height="height"
        />
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    name: 'SimpleSpinner',
    props: {
        height: {
            type: [String, Number],
            default: 32,
        },
        width: {
            type: [String, Number],
            default: 32,
        },
    },
    computed: {
        ...mapState(['localizations', 'lang']),
    },
};
</script>
<style scoped>
.SimpleSpinner {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
